class TransfersTableController {
  constructor($sce, $timeout, $filter, $translate, transfersTableService, sharedService, moment) {
    'ngInject';

    //TODO: Get airport names by selected language
    //Dependencies
    this.name = 'transfersTable';
    this.transfersTableService = transfersTableService;
    this.loader = sharedService.loader;
    this.transfersTableFilter = $filter('transfersTableFilter');
    this.$translate = $translate;
    this.showMoreButton = true;
    this.moment = moment;
    this.$timeout = $timeout;
    this.$sce = $sce;
    this.isSuccess = false;

    this.style = "";
    this.isUploading = false;
    this.uploadMessage = "";
    this.uploadSuccess = false;
    this.uploadFileName = "";
    this.showPopup = false;


    this.gateways = null;
    this.leftFilterName = {};
    this.labelTypes = {
      0: 'danger',
      1: 'warning',
      2: 'default'
    };
    this.formatDate = 'YYYY-MM-DD HH:mm:ss';
    this.filterDateFormat = 'YYYY-MM-DD';

    // Dropdown Filter
    // TODO: move to component
    this.DropdownFilterText = this.$translate.instant('dropdown_all_transfers');
    this.exceededPickupTimeErrorText = this.$translate.instant('exceeded_pickup_time_error');

    // Left dropdown conf
    this.leftFilterItems = [
      {
        name: 'dropdown_all_transfers',
        filter: ''
      },
      {
        name: 'dropdown_transfer_no_pickup',
        filter: {
          pickupTime: '!'
        }
      }
    ];

    //Transfers
    this.transfers = [];
    this.getGateways(this.moment().add(2, 'days').format(this.filterDateFormat));
  };


  datepickerOnChange(item) {

      let max = this.moment(item.transfersTable.datePicker.options.maxDate);
      let selected = this.moment(item.transfersTable.datePicker.options.dateModel);

      if (selected.isSame(max, 'day')) {
        item.transfersTable.timePicker.model = this.moment(item.transfersTable.datePicker.options.maxDate).toDate();
      } else {
        item.transfersTable.timePicker.model = this.moment(item.transfersTable.datePicker.options.minDate).toDate();
      }
  }

  toggleLoader() {
    this.loader.visible = !this.loader.visible;
  }

  getTransfersByGateway(gatewayId, endDate) {
    //Get transfers data
    this.toggleLoader();
    this.transfersTableService.getTransfersByGateway(gatewayId, this.formatDate, endDate)
      .then(data => {
        data.forEach((item) => {
          this.checkDates(item);
        });
        this.transfers = data;
      })
      .finally(() => {
        this.toggleLoader();
      });
  };

  showMoreTransfers() {
    this.showMoreButton = false;
    this.getTransfersByGateway(this.getSelectedGatewayIds(), this.moment().add(6, 'days').format(this.filterDateFormat));
  }

  getGateways(endDate) {
    this.toggleLoader();
    this.transfersTableService.getGateways()
      .then(data => {
        this.gateways = [{ id: 'all', name: 'All Gateways' }, ...data.gateways];
        this.gateways.gatewayIds = this.gateways
          .filter(gateway => gateway.id !== 'all')
          .map(gateway => gateway.id)
          .join(',');
        if (this.gateways.length > 1) {
          this.getTransfersByGateway(this.gateways.gatewayIds, endDate);
        }
      })
      .finally(() => {
        this.toggleLoader();
      });
  };

  toogleLoaderAndSumbit(transferToUpdate) {
    transferToUpdate.map((item) => item.transfersTable.saving = !item.transfersTable.saving);
  }

  saveTransfers() {
    let transferToUpdate = this.transfers.filter((item) => (angular.isObject(item.pickupTime) || item.transfersTable.pickupPoint !== item.pickupPoint) && item.transfersTable.pickupTimeSaved === false && item.transfersTable.pickupPointSaved === false && item.transfersTable.saving === false);
    if (transferToUpdate.length === 0) {
      return;
    }

    this.toogleLoaderAndSumbit(transferToUpdate);
    this.transfersTableService.saveTransfers(
      this.transfersTableService.transferCollectionDataTransformerRequest(transferToUpdate, this.formatDate)
    )
      .then(response => {
        if (response === null) {
          return transferToUpdate.map((item) => {
            item.transfersTable.pickupTimeSaved = true;
            item.transfersTable.pickupPointSaved = true;
          });
        }

        transferToUpdate.forEach((item) => {
          item.transfersTable.pickupTimeSaved = response[item.transferId] || false;
          item.transfersTable.pickupPointSaved = response[item.transferId] || false;
        });
      })
      .finally(() => {
        this.toogleLoaderAndSumbit(transferToUpdate);
      });
  }

  //TODO Move to a filter
  formatDateToString(timestamp) {
    let myDate = new Date(timestamp);
    return this.transfersTableFilter(myDate) + ' at ' + myDate.toLocaleTimeString('en-US', {
        hour12: false,
        hour: "numeric",
        minute: "numeric"
      });
  }

  checkDates(item) {
    // If no pickupTime set FlightTime as defaults
    if (item.pickupTime) {
      this.setDatePickerOptions(item, item.pickupTime);
    } else {
      this.setDatePickerOptions(item, item.flightTime);
    }
  }

  setDatePickerOptions(item, date) {
    //Set initDate, maxDate and dateModel
    item.transfersTable.datePicker.options.initDate = item.flightTime;
    item.transfersTable.flightTimeDateConcat = this.formatDateToString(item.flightTime);
    item.transfersTable.datePicker.options.dateModel = new Date(date);
    item.transfersTable.pickupTimeDateConcat = this.formatDateToString(date);
    item.transfersTable.shuttleLatestPickupTime = this.formatDateToString(item.shuttleLatestPickupTime);
    item.transfersTable.latestPickupTimeDateConcat = this.formatDateToString(item.latestPickupTime);
    item.transfersTable.earliestPickupTimeDateConcat = this.formatDateToString(item.earliestPickupTime);
  }

  isPickupTimeValid(item) {
     return (item.transfersTable.timePicker.model >= item.transfersTable.timePicker.min) && (item.transfersTable.timePicker.model <= item.transfersTable.timePicker.max);
  }

  saveFieldDate(item, $event) {
    $event.stopPropagation();
    $event.preventDefault();

    item.transfersTable.dropdownIsOpen = false;
    item.transfersTable.datePicker.options.isOpen = false;

    let model;
    if (item.labelType > 0) {
      item.transfersTable.datePicker.options.dateModel.setHours(item.transfersTable.timePicker.model.getHours());
      item.transfersTable.datePicker.options.dateModel.setMinutes(item.transfersTable.timePicker.model.getMinutes());
      model = item.transfersTable.datePicker.options.dateModel;
    } else {
      model = item.transfersTable.timePicker.model;
    }
    item.pickupTime = model;
    item.transfersTable.pickupTimeDateConcat = this.formatDateToString(model);
  }

  toggleDropdownOffClick(item) {
    item.transfersTable.datePicker.options.isOpen = false;
    item.transfersTable.dropdownIsOpen = false;
    item.transfersTable.pointPicker.options.isOpen = false;
    item.transfersTable.dropdownPickupPointIsOpen = false;
  }

  toggleDatePicker(item, $event) {
    $event.stopPropagation();
    $event.preventDefault();
    item.transfersTable.datePicker.options.isOpen = !item.transfersTable.datePicker.options.isOpen;
  }

  togglePickupPointEdit(item, $event) {
    $event.stopPropagation();
    $event.preventDefault();

    if (item.transfersTable.saving) {
      item.transfersTable.dropdownPickupPointIsOpen = false;
      return;
    }

    item.transfersTable.dropdownPickupPointIsOpen = !item.transfersTable.dropdownPickupPointIsOpen;
    item.transfersTable.tempPickupPoint = item.pickupPoint;
  };

  savePickupPoint(item, $event) {
    $event.stopPropagation();
    $event.preventDefault();

    item.pickupPoint = item.transfersTable.tempPickupPoint;
    item.transfersTable.dropdownPickupPointIsOpen = false;
  }

  togglePickupTimeDropdown($event, item) {
    $event.stopPropagation();
    $event.preventDefault();
    if (item.transfersTable.saving) {
      item.transfersTable.dropdownIsOpen = false;
      return;
    }

    item.transfersTable.dropdownIsOpen = !item.transfersTable.dropdownIsOpen;

  }

  downloadExcel() {
    this.toggleLoader();
    let endDate = this.moment().add(6, 'days').format(this.filterDateFormat);
    let onlyTransfersWithoutPickupTime = (this.leftFilterName && this.leftFilterName.pickupTime) ? 1 : 0;
    this.transfersTableService.downloadTransfersExcel(this.getSelectedGatewayIds(), endDate, this.getSelectedGatewayCod(), onlyTransfersWithoutPickupTime)
      .finally(() => this.toggleLoader());
  }


  uploadExcel() {
    const fileInput = document.getElementById('fileInput');

    if (!fileInput || !fileInput.files.length) {
      this.$timeout(() => {
        this.uploadMessage = "Please select a file before uploading.";
        this.uploadSuccess = false;
        this.showPopup = true;
      });
      return;
    }

    this.isUploading = true; // Disable button
    const file = fileInput.files[0];
    this.uploadFileName = file.name;

    const formData = new FormData();
    formData.append('transfers_file', file);

    this.transfersTableService.uploadTransfersExcel(formData)
      .then(data => {
        this.$timeout(() => {
          if (data && data.success) {
            const updatedCount = data.summary.updated_entities.length;
            const totalCount = data.summary.entities_to_update.length;

            let messageTitle = "All transfers updated successfully.";
            let warningMessage = `Possible reasons:<br>
              - Invalid Transfer Reference. Valid formats are: SUNTR_XX0000/1 or SUNTR_XX0000/2 <br>
              - Invalid Pickup Time. Valid format is: year-month-day hour:minute, e.g. 2025-03-25 17:50 <br>
              - No changes were made: You're updating the Pickup Time to a time that was already set.`;


            let messageStyle = "success";
            if (updatedCount === 0) {
              messageTitle = "Attention: No transfers were updated.";
              messageStyle = "warning";
            } else if (updatedCount !== totalCount) {
              messageTitle = `Attention: Transfers updated out of ${totalCount}: ${updatedCount}`;
              messageStyle = "warning";
            }

            let message = messageTitle;
            if (messageStyle === "warning") {
              message += "<br><br>" + warningMessage;
            }

            this.uploadMessage = this.$sce.trustAsHtml(message);
            this.uploadSuccess = true;
            this.style = messageStyle;
          } else {
            this.uploadMessage = this.$sce.trustAsHtml(`❌ Upload failed for '${this.uploadFileName}'. Review the file or contact devops@suntransfers.com.`);
            this.uploadSuccess = false;
            this.style = "error";
          }
          this.showPopup = true;
          this.isUploading = false;
        });
      })
      .catch(error => {
        this.$timeout(() => {
          this.uploadMessage = this.$sce.trustAsHtml(`❌ Error occurred while processing the file. Please try again later.`);
          this.uploadSuccess = false;
          this.style = "error";
          this.showPopup = true;
          this.isUploading = false;
        });
      });
  }

  closePopup () {
    this.showPopup = false;
    window.location.reload();
  };

  handleGatewayChange(selectedGateway) {
    this.gateways.selectedGateway = selectedGateway;
    let endDate = this.moment().add(6, 'days').format(this.filterDateFormat);
    if (this.gateways.selectedGateway === 'all') {
      this.getTransfersByGateway(this.gateways.gatewayIds, endDate);
    } else {
      this.getTransfersByGateway(this.gateways.selectedGateway, endDate);
    }
  }

  handleFilterChange(selectedFilter) {
    this.leftFilterName = selectedFilter.name;
  }

  getSelectedGatewayIds() {
    return this.gateways.selectedGateway === undefined || this.gateways.selectedGateway === "all"
      ? this.gateways.gatewayIds
      : this.gateways.selectedGateway;
  }

  getSelectedGatewayCod(){
    let gateway = this.gateways.find(g => g.id === this.gateways.selectedGateway);
    return gateway ? gateway.cod : "ALL";
  }
}

export default TransfersTableController;



// WEBPACK FOOTER //
// ./client/app/common/transfersTable/transfersTable.controller.js